export default __webpack_public_path__ + "static/media/edit-comment-icon.c6e89e31.svg";